/**
 *
 * HighPriorityMemberBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';

import DiamondIcon from 'assets/v2/DiamondIcon';
import { COLORS } from 'theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.goldMetalicDark};
    background: ${COLORS.goldMetalicLight};
    border-color: ${COLORS.goldMetalic};
  }

  &.MuiButtonBase-root.MuiChip-root:hover {
    background-color: ${COLORS.goldMetalicLight};
    opacity: 0.88;
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.goldMetalic};
    }
  }
`;

const CenteredSpinner = styled(CircularProgress)`
  position: absolute;
  transform: translate(-50%, -50%);
`;

function HighPriorityMemberBadge({ loading, ...props }) {
  return (
    <StyledBadge
      label="High Priority Member"
      icon={
        <>
          <DiamondIcon />
          {loading && <CenteredSpinner size={19} color="inherit" />}
        </>
      }
      {...props}
    />
  );
}

HighPriorityMemberBadge.propTypes = {
  loading: PropTypes.bool,
};

export default memo(HighPriorityMemberBadge);
